import { render, staticRenderFns } from "./OrganisationGouvernanceComp.vue?vue&type=template&id=afa5cac4&scoped=true"
import script from "./OrganisationGouvernanceComp.vue?vue&type=script&lang=js"
export * from "./OrganisationGouvernanceComp.vue?vue&type=script&lang=js"
import style0 from "./OrganisationGouvernanceComp.vue?vue&type=style&index=0&id=afa5cac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa5cac4",
  null
  
)

/* custom blocks */
import block0 from "./OrganisationGouvernanceComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports